// #336 slice 5, brief §5.4 and Appendix A: the tetrad's rounds. The tetrad
// itself is a program model in the DB (#351, programModel.ts); what stays in
// code is the block «+ 4 rounds» adds (flow 9). Keep free of React and any UI import.
import type { RoundType } from "./schemas/programV3.js";

/** One tetrad's rounds: the third measures, the fourth deloads. */
export const TETRAD_ROUND_TYPES: readonly RoundType[] = ["normal", "normal", "test", "deload"];
